export default {
    toggleUserBasket: 'USER_TOGGLE_BASKET',
    list: {
        setData: 'BASKET_LIST_SET_DATA',
        setLoading: 'BASKET_LIST_SET_LOADING',
    },
};
